// URL safety for links and redirects the server hands us.
//
// These values originate at Stripe or in our own settings table, so a hostile
// scheme is not the expected case - the guard is here so that a compromised or
// simply wrong API response cannot turn into navigation to `javascript:` or an
// off-site page. Cheap, and applied uniformly: guarding the receipt link but not
// the checkout redirect, in the same file, was the inconsistency worth removing.

export const isSafeUrl = (url) => /^https?:\/\//i.test(String(url || ''));

// Send the browser to an external URL, refusing anything that is not absolute
// http(s). Returns false when it refused, so callers can surface an error.
export function goTo(url) {
  if (!isSafeUrl(url)) return false;
  window.location.href = url;
  return true;
}
